import React from 'react';
import { styled } from '@mui/material/styles';

const Wrapper = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  paddingTop: '1em',
  [theme.breakpoints.down('md')]: {
    minHeight: 'auto',
    paddingTop: '0.5em',
  },
}));

const OuterContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  background: (theme.palette as any).blue?.light || '#e3f2fd',
  padding: compact ? '3px' : '5px',
  borderRadius: '20px',
  margin: compact ? '0.5em' : '1em',
  boxSizing: 'border-box',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.19)',
  width: '100%',
  height: 'fit-content',
  [theme.breakpoints.down('md')]: {
    margin: 0,
    borderRadius: 0,
    padding: '3px 0',
  },
}));

const InnerContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'compact',
})<{ compact?: boolean }>(({ theme, compact }) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: '15px',
  padding: compact ? '1em 0.75em' : '2.6em',
  textAlign: 'left',
  color: theme.palette.grey[400],
  width: '100%',
  boxSizing: 'border-box',
  [theme.breakpoints.down('xl')]: {
    padding: '1em',
    fontSize: '0.9em',
  },
  [theme.breakpoints.down('md')]: {
    padding: '0.5em',
    borderRadius: 0,
  },
}));

const SidebarWrapper: React.FC<{ children: React.ReactNode; compact?: boolean }> = ({ children, compact }) => (
  <Wrapper>
    <OuterContainer compact={compact}>
      <InnerContainer compact={compact}>{children}</InnerContainer>
    </OuterContainer>
  </Wrapper>
);

export default SidebarWrapper;
